/*
Loons Lab loonsDialogBox component
Developed By Sandun
Loons Lab
*/
import React, { Component } from 'react'

import {
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Button,
    Typography,
} from '@material-ui/core'

import { Alert } from '@material-ui/lab'

import { scrollToTop } from 'utils'
import PropTypes from 'prop-types'

class LoonsDialogBox extends Component {
    static propTypes = {
        title: PropTypes.string,
        title_text_variant: PropTypes.string,

        show_alert: PropTypes.bool,
        alert_severity: PropTypes.string,
        alert_message: PropTypes.string,

        message: PropTypes.string,

        open: PropTypes.bool,
        show_button: PropTypes.bool,

        btn_variant: PropTypes.string,
        btn_color: PropTypes.string,
        btn_type: PropTypes.string, //submit or not
        btn_label: PropTypes.string,

        btn_children: PropTypes.node,
        body_children: PropTypes.node,
    }

    static defaultProps = {
        open: false,
        name: 'loons_snackBar',
        title: '',
        title_text_variant: 'h5',

        show_alert: false,
        alert_severity: 'success',
        alert_message: '',
        message: '',

        show_button: false,
        btn_variant: 'contained',
        btn_color: 'primary',
        btn_type: '', //submit or not
        btn_label: 'OK',
    }

    // scrollToTop() {
    //     scrollToTop()
    // }

    handleButtonClose = (event) => {
        const { onClose } = this.props
        onClose &&
            onClose({
                event,
            })
    }

    renderChildren = (label, children) => {
        if (label) {
            return label
        }

        if (children) {
            return children
        }
    }

    render() {
        const {

            open,

            title,
            title_text_variant,

            show_alert,
            alert_severity,
            alert_message,
            body_children,
            message,

            show_button,
            btn_variant,
            btn_color,
            btn_type,
            btn_label,
            btn_children,
        } = this.props

        return (
            <Dialog open={open} name="dialogBox">
                <DialogTitle>
                    <Typography variant={title_text_variant}>
                        {title}
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    {/* other body content */}
                    {this.renderChildren(message, body_children)}

                    {show_alert === true && (
                        <Alert severity={alert_severity}>
                            <strong>{alert_message}</strong>
                        </Alert>
                    )}
                </DialogContent>

                <DialogActions>
                    {show_button === true && (
                        <Button
                            variant={btn_variant}
                            color={btn_color}
                            type={btn_type}
                            onClick={this.handleButtonClose} //close dialog box
                        >
                            {this.renderChildren(btn_label, btn_children)}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        )
    }
}

export default LoonsDialogBox
